// tslint:disable: max-line-length
import { checkStatus, fetchRetry, parseJSON } from './utils';

const getGraphQLResponse = (headers, b) =>
  fetchRetry(
    `${window.config.REACT_APP_BASE_URL}/api/analytics/graphql`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify(b)
    },
    3,
    1000
  )
    .then(checkStatus)
    .then(parseJSON);

const generateHeaders = (locale, authorization) => ({
  Accept: 'application/vnd.novus+json; version=1',
  'Content-Type': 'application/json',
  'Accept-Language': locale,
  Authorization: authorization
});

export const getSessionsQuery = (startDate, endDate, utcOffset, userGroupId) =>
  `viewsBySession: portalSessionVisit(
    startDate: ${startDate},
    ${userGroupId && `userGroupId: ${userGroupId},`}
    endDate: ${endDate},
    utcOffset: ${utcOffset},
  ) { dateVisited hits }`;

export const getViewsByDateQuery = (
  startDate,
  endDate,
  utcOffset,
  userGroupId
) =>
  `viewsByDate: portalPageVisit(
    startDate: ${startDate},
    endDate: ${endDate},
    utcOffset: ${utcOffset},
    ${userGroupId && `userGroupId: ${userGroupId},`}
    groupBy: Date
  ) { dateVisited hits }`;

export const getViewsByPageQuery = (
  startDate,
  endDate,
  selectedLanguage,
  limit,
  skip,
  userGroupId
) =>
  `viewsByPage: portalPageViews(
    startDate: ${startDate},
    endDate: ${endDate},
    first: ${limit},
    offset: ${skip},
    ${userGroupId && `userGroupId: ${userGroupId},`}
    language: ${selectedLanguage}
  ) { total pages { hits uniqueHits pageTitle } }`;

export const getOSVisitQuery = (startDate, endDate, userGroupId) =>
  `viewsByOSVisits: portalOsVisit(
    startDate: ${startDate},
    endDate: ${endDate},
    ${userGroupId && `userGroupId: ${userGroupId},`}
    groupBy: OS
  ) { os hits }`;

export const getBrowserVisitQuery = (startDate, endDate, userGroupId) =>
  `viewsByBrowserVisits: portalBrowserVisit(
    startDate: ${startDate},
    endDate: ${endDate},
    ${userGroupId && `userGroupId: ${userGroupId},`}
    groupBy: Browser
  ) { browser hits }`;

export const getHraCampaignStatsQuery = (
  startDate,
  endDate,
  userGroupId,
  type
) =>
  `hraCampaignStatistics${type}: hraCampaignStats(
    startDate: ${startDate},
    endDate: ${endDate},
    ${userGroupId && `userGroupId: ${userGroupId},`}
    type: ${type}
  ) { hits }`;

export const getSurveyStatsQuery = (
  startDate,
  endDate,
  userGroupId,
  type,
  surveyIds
) =>
  `surveyStatistics${type}: portalSurveyVisit(
    startDate: ${startDate},
    endDate: ${endDate},
    ${userGroupId && `userGroupId: ${userGroupId},`}
    type: ${type},
    surveyIds: [${surveyIds}]
  ) { hits }`;

export const getSHAWData = (startDate, endDate, userGroupId) =>
  `shawData: portalSurveyVisitData(
    startDate: ${startDate},
    endDate: ${endDate},
    ${userGroupId && `userGroupId: ${userGroupId},`}
    getLanguage: true
  ) { hits condition locale }`;

export const getRequestedCallbackQuery = (startDate, endDate, userGroupId) =>
  `surveyDataRequestedCallback: portalSurveyVisitData(
    startDate: ${startDate},
    endDate: ${endDate},
    ${userGroupId && `userGroupId: ${userGroupId},`}
    requestedCallback: true
  ) { hits condition }`;

export const getEligibleResponsesQuery = (startDate, endDate, userGroupId) =>
  `surveyDataEligibleResponses: portalSurveyVisitData(
    startDate: ${startDate},
    endDate: ${endDate},
    ${userGroupId && `userGroupId: ${userGroupId},`}
    eligibleResponses: true
  ) { hits }`;

export const getViews = (
  authorization,
  locale,
  startDate,
  endDate,
  utcOffset,
  selectedLanguage,
  limit,
  skip,
  userGroupId
) => {
  const Headers = generateHeaders(locale, authorization);
  const query = {
    query: `query {
      ${getViewsByDateQuery(startDate, endDate, utcOffset, userGroupId)}
      ${getViewsByPageQuery(
        startDate,
        endDate,
        selectedLanguage,
        limit,
        skip,
        userGroupId
      )}
      ${getSessionsQuery(startDate, endDate, utcOffset, userGroupId)}
      ${getOSVisitQuery(startDate, endDate, userGroupId)}
      ${getBrowserVisitQuery(startDate, endDate, userGroupId)}
      ${getHraCampaignStatsQuery(startDate, endDate, userGroupId, 'Start')}
      ${getHraCampaignStatsQuery(startDate, endDate, userGroupId, 'Complete')}
      ${getSurveyStatsQuery(
        startDate,
        endDate,
        userGroupId,
        'Start',
        '"shaw_survey","mhshaw_survey"'
      )}
      ${getSurveyStatsQuery(
        startDate,
        endDate,
        userGroupId,
        'Complete',
        '"shaw_survey","mhshaw_survey"'
      )}
    }`
  };
  return getGraphQLResponse(Headers, query);
};

export const getSHAWAnalytics = (
  authorization,
  locale,
  startDate,
  endDate,
  userGroupId
) => {
  const Headers = generateHeaders(locale, authorization);
  const query = {
    query: `query {
      ${getSurveyStatsQuery(
        startDate,
        endDate,
        userGroupId,
        'Start',
        '"shaw_survey","mhshaw_survey"'
      )}
      ${getSurveyStatsQuery(
        startDate,
        endDate,
        userGroupId,
        'Complete',
        '"shaw_survey","mhshaw_survey"'
      )}
      ${getSHAWData(startDate, endDate, userGroupId)}
      ${getRequestedCallbackQuery(startDate, endDate, userGroupId)}
      ${getEligibleResponsesQuery(startDate, endDate, userGroupId)}
    }`
  };
  return getGraphQLResponse(Headers, query);
};

export const getCallCenterReports = (authorization, locale, directory) => {
  const apiEndpoint = `${
    window.config.REACT_APP_BASE_URL
  }/api/analytics/call_center_reports${directory ? `/${directory}` : ``}`;

  return fetch(apiEndpoint, {
    method: 'GET',
    headers: generateHeaders(locale, authorization)
  })
    .then(checkStatus)
    .then(parseJSON);
};



// WEBPACK FOOTER //
// ./src/api/analytics.js